import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import type { Component, TransformData } from '@wix/thunderbolt-becky-types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { DEFAULT_VARIANT_KEY } from './constants'
import { isRefArray } from '../../utils/variantsUtils'
import { BreakpointToOpacity } from './componentsVisibility.types'

export const componentsVisibility = createCssCompNode('componentsVisibility', 'componentsVisibility', {
	getDependencies: (component: Component, refs: FeatureRefs<'componentsVisibility'>) =>
		component.transformationQuery
			? {
					transformationRefArray: refs.transformationQuery(component.transformationQuery),
					transparentComponentsOverlay: envRefs.transparentComponentsOverlay,
					props: component.propertyQuery ? refs.propertyQuery(component.propertyQuery) : null,
			  }
			: null,
	toViewItem: (component, data) => {
		if (
			!data ||
			!isRefArray(data.transformationRefArray) ||
			typeof data.transparentComponentsOverlay === 'undefined'
		) {
			return null
		}

		const { props, transparentComponentsOverlay, transformationRefArray } = data
		const breakpointToTransformation = transformationRefArray
			? toBreakpointVariantsMap(transformationRefArray.values, (x) => x)
			: {}
		const breakpointToOpacity = Object.entries(breakpointToTransformation).reduce<BreakpointToOpacity>(
			(acc, [breakpoint, transformation]) => {
				const defaultTransformation = transformation[DEFAULT_VARIANT_KEY]
				acc[breakpoint] = (defaultTransformation as TransformData)?.opacity
				return acc
			},
			{}
		)

		return {
			isHidden: !!(props as any)?.isHidden,
			isCollapsed: !!(props as any)?.isCollapsed,
			breakpointToOpacity,
			transparencyThreshold: transparentComponentsOverlay,
		}
	},
})
